import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import { MarketsPage, marketsQueryOptions } from '@/features/markets';

export const Route = createFileRoute('/_authed/_active/s/$storeId/settings/markets')({
  staticData: { crumb: 'common:nav.markets', tours: ['settings.markets'] },
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'settings.read');
  },
  loader: ({ context, params }) =>
    context.queryClient
      .query({ ...marketsQueryOptions(params.storeId), staleTime: 'static' })
      .catch(() => undefined),
  component: MarketsPage,
});
